import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useTalentMobilityScopeStore
 *
 * Single source of truth for the Talent Mobility "Full Org / My Team" scope
 * override. Previously this lived as a per-call-site useState inside
 * useScopeToggle (useTalentMobilityData.js) — since multiple hooks
 * (useTalentMobilityEmployees, useRedeploymentCandidates, the page component
 * itself) each called that hook independently, toggling the switch in one
 * place silently didn't affect the others (separate React state per call
 * site). Moving it into a shared
 * store fixes that and lets the default be derived from the real logged-in
 * profileRole (see useScopeToggle) instead of always defaulting to full org.
 *
 * `manualScope: null` means "no explicit override — derive from profileRole".
 * Session-only by design — Talent Mobility data must not live in localStorage.
 */
const useTalentMobilityScopeStore = create(
  devtools(
    (set) => ({
      manualScope: null,
      setManualScope: (scope) => set({ manualScope: scope }),
      clearManualScope: () => set({ manualScope: null }),
    }),
    { name: 'TalentMobilityScopeStore' }
  )
);

export default useTalentMobilityScopeStore;
